const mobileMenu = document.querySelector("#mobile-navigation")
let closeMenuButton
let navItems
let navImages
let defaultImage

window.addEventListener("load", (event) => {
  if (mobileMenu && findHtmlElements()) {
    addCloseButtonListener()
    addNavItemsListeners()
    showImage()
    monitorNestedNavItems()
  }
})

function findHtmlElements() {
  closeMenuButton = mobileMenu.querySelector(".close-menu-btn")
  navItems = mobileMenu.querySelectorAll("#navigation-mobile > ul > li")
  navImages = mobileMenu.querySelectorAll(".navigation-img")
  defaultImage = mobileMenu.querySelector(".default-image")
  return closeMenuButton && navItems && navImages
}

function addCloseButtonListener() {
  closeMenuButton.addEventListener("click", (event) => {
    window.MobileMenu.close()
  })
}

function addNavItemsListeners() {
  navItems.forEach((navItem) => {
    navItem.addEventListener("mouseover", (event) => {
      showImage(navItem)
    })
  })
}

function showImage(navItem = null) {
  let foundImage = false
  if (navItem) {
    navImages.forEach((navImage) => {
      navImage.style.opacity = "0"
      if (navImage.dataset.url && navImage.dataset.url == navItem?.querySelector("a")?.getAttribute("href")) {
        navImage.style.opacity = "100"
        foundImage = true
      }
    })
  }

  if (!foundImage && defaultImage) {
    defaultImage.style.opacity = "100"
  }
}

const monitorNestedNavItems = () => {
  const openButtons = document.querySelectorAll("nav > ul > li > button.navigation-open-slide")
  const closeButtons = document.querySelectorAll("nav button.navigation-close-slide")

  if (openButtons && closeButtons && mobileMenu) {
    openButtons.forEach(openButton => {
      openButton.addEventListener("click", () => {
        mobileMenu.classList.add('nested-open')
      });
    });

    closeButtons.forEach(closeButton => {
      closeButton.addEventListener("click", () => {
        mobileMenu.classList.remove('nested-open')
      });
    });
  }
}




